var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsimg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 78,
    viewBox: "0 0 112 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4615 77.3693C81.4352 77.3693 104.923 72.7223 104.923 66.9898C104.923 61.2574 81.4352 56.6104 52.4615 56.6104C23.4878 56.6104 0 61.2574 0 66.9898C0 72.7223 23.4878 77.3693 52.4615 77.3693Z",
    fill: "#EEE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8774 0.451172H29.1226C25.7412 0.451172 23 3.68613 23 7.67666V60.2257C23 64.2162 25.7412 67.4512 29.1226 67.4512H75.8774C79.2588 67.4512 82 64.2162 82 60.2257V7.67666C82 3.68613 79.2588 0.451172 75.8774 0.451172Z",
    fill: "url(#paint0_linear_822_5296)",
    stroke: "#BCA7FA",
    strokeWidth: 0.902564
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3844 12.9897H34.4101C33.4754 12.9897 32.7178 13.7474 32.7178 14.6821C32.7178 15.6167 33.4754 16.3744 34.4101 16.3744H69.3844C70.3191 16.3744 71.0767 15.6167 71.0767 14.6821C71.0767 13.7474 70.3191 12.9897 69.3844 12.9897Z",
    fill: "#9A7AF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5639 24.272H34.4101C33.4754 24.272 32.7178 25.0296 32.7178 25.9643C32.7178 26.8989 33.4754 27.6566 34.4101 27.6566H66.5639C67.4986 27.6566 68.2562 26.8989 68.2562 25.9643C68.2562 25.0296 67.4986 24.272 66.5639 24.272Z",
    fill: "#9A7AF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4614 35.5537H34.4101C33.4754 35.5537 32.7178 36.3114 32.7178 37.246C32.7178 38.1807 33.4754 38.9383 34.4101 38.9383H52.4614C53.396 38.9383 54.1537 38.1807 54.1537 37.246C54.1537 36.3114 53.396 35.5537 52.4614 35.5537Z",
    fill: "#9A7AF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8462 66.9898C85.6348 66.9898 91.9488 60.6759 91.9488 52.8872C91.9488 45.0986 85.6348 38.7847 77.8462 38.7847C70.0576 38.7847 63.7437 45.0986 63.7437 52.8872C63.7437 60.6759 70.0576 66.9898 77.8462 66.9898Z",
    fill: "url(#paint1_linear_822_5296)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1501 56.2447H76.762C76.7558 55.9013 76.7527 55.6922 76.7527 55.6173C76.7527 54.8431 76.8807 54.2063 77.1366 53.7068C77.3926 53.2073 77.9046 52.6454 78.6725 52.0211C79.4404 51.3968 79.8993 50.9878 80.0492 50.7943C80.2802 50.4884 80.3957 50.1512 80.3957 49.7829C80.3957 49.2709 80.1896 48.8339 79.7776 48.4718C79.3718 48.1034 78.8223 47.9192 78.1293 47.9192C77.4613 47.9192 76.9025 48.1097 76.453 48.4905C76.0035 48.8713 75.6944 49.452 75.5259 50.2324L73.1097 49.9327C73.1784 48.8152 73.6529 47.8662 74.5332 47.0857C75.4197 46.3053 76.581 45.9151 78.017 45.9151C79.5278 45.9151 80.7297 46.3116 81.6225 47.1045C82.5153 47.8911 82.9617 48.8089 82.9617 49.8578C82.9617 50.4384 82.7962 50.9878 82.4653 51.506C82.1407 52.0242 81.4414 52.7297 80.3676 53.6225C79.8119 54.0845 79.4654 54.456 79.328 54.7369C79.1969 55.0179 79.1376 55.5205 79.1501 56.2447ZM76.762 59.7847V57.1531H79.3936V59.7847H76.762Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.41 19.6052L104.359 14.5283Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.41 19.6052L104.359 14.5283",
    stroke: "url(#paint2_linear_822_5296)",
    strokeWidth: 2.03077,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.359 27.5028L110 26.1489Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.359 27.5028L110 26.1489",
    stroke: "url(#paint3_linear_822_5296)",
    strokeWidth: 2.03077,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.359 35.3999L109.436 38.2204Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.359 35.3999L109.436 38.2204",
    stroke: "url(#paint4_linear_822_5296)",
    strokeWidth: 2.03077,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100.271 26.827L99.3933 25.9495C98.8646 25.4208 98.0074 25.4208 97.4787 25.9495L96.6012 26.827C96.0725 27.3557 96.0725 28.213 96.6012 28.7417L97.4787 29.6192C98.0074 30.1479 98.8646 30.1479 99.3933 29.6192L100.271 28.7417C100.8 28.213 100.8 27.3557 100.271 26.827Z",
    fill: "#C5B4FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_822_5296",
    x1: 23,
    y1: 0.451172,
    x2: 89.462,
    y2: 58.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_822_5296",
    x1: 63.7437,
    y1: 38.7847,
    x2: 91.9488,
    y2: 66.9898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B25FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4611E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_822_5296",
    x1: 100.41,
    y1: 14.5283,
    x2: 105.331,
    y2: 18.3555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B25FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4611E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_822_5296",
    x1: 104.359,
    y1: 26.1489,
    x2: 104.973,
    y2: 28.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B25FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4611E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_822_5296",
    x1: 104.359,
    y1: 35.3999,
    x2: 106.754,
    y2: 39.7105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B25FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4611E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsimg);
export default __webpack_public_path__ + "static/media/questionsimg.5ca3d55411d5d936f961014318623564.svg";
export { ForwardRef as ReactComponent };